"use strict";

import Swiper from 'swiper';
import { FreeMode } from 'swiper/modules';
import { withCarouselNav, syncCarouselNavVisibility } from './carousel-nav';

const SELECTOR = '[data-articles-carousel]';

function initArticlesCarousel() {
	document.querySelectorAll(SELECTOR).forEach(function (el) {
		if (el.swiper) {
			return;
		}

		const swiper = new Swiper(el, withCarouselNav(el, {
			modules: [FreeMode],
			slidesPerView: 1.15,
			spaceBetween: 40,
			slidesOffsetBefore: 40,
			grabCursor: true,
			freeMode: {
				enabled: true,
				momentumRatio: 0.85,
				momentumVelocityRatio: 0.85,
			},
			breakpoints: {
				768: {
					slidesPerView: 2.5,
				},
				1200: {
					slidesPerView: 3.5,
				},
			},
		}));

		syncCarouselNavVisibility(swiper);
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initArticlesCarousel, { once: true });
} else {
	initArticlesCarousel();
}
